import React, { useEffect, useState } from 'react';

import SearchIcon from 'icons/search.svg';
import PropTypes from 'prop-types';

import useDebounce from 'components/hooks/useDebounce';

import CollectionSelect from 'components/application/CollectionSelect';
import Toggleable from 'components/application/Toggleable';

import AddButton from 'components/buttons/AddButton';

export default function ToggleableSelect(props) {
  const [isToggled, setIsToggled] = useState(false);

  const [select, setSelect] = useState({ inputValue: null, callback: null });

  const [debouncedInputValue, resetDebouncedInputValue] = useDebounce(
    select.inputValue,
    250,
  );

  const resourceOption = (resource) => ({
    label: resource.attributes.name,
    value: { resource },
    disabled: props.isOptionDisabled ? props.isOptionDisabled(resource) : false,
    sublabel: props.renderSublabel ? props.renderSublabel(resource) : null,
  });

  const fetchOptions = () => {
    if (debouncedInputValue && debouncedInputValue.length > 0) {
      axios
        .get(props.url, { params: { search: debouncedInputValue } })
        .then((response) =>
          select.callback(
            response.data.data.map((resource) => resourceOption(resource)),
          ),
        )
        .catch(() => props.onError && props.onError());
    } else {
      select.callback([]);
    }
  };

  const loadOptions = (inputValue, callback) =>
    setSelect({ inputValue, callback });

  const handleFocus = () => {
    props.onFocus && props.onFocus();
    resetDebouncedInputValue();
  };

  const handleBlur = () => {
    setIsToggled(false);
  };

  const handleChange = (selected, actionMeta) => {
    props.onChange(selected, actionMeta);
    setIsToggled(false);
  };

  const isOptionDisabled = (option) => option.disabled;

  useEffect(() => {
    if (select.callback) {
      fetchOptions();
    }
  }, [debouncedInputValue]);

  return (
    <Toggleable
      isToggled={isToggled}
      primary={
        <AddButton
          onClick={props.onToggleablePrimaryClick}
          text={props.buttonText}
        />
      }
      secondary={
        <div className='tw-relative'>
          <SearchIcon
            className='search-field__toggleable-icon tw-z-[1] tw-ml-[5px] tw-mt-[5px] [&_path]:tw-fill-grey-700'
            height={24}
            width={30}
          />
          <div className='tw-w-115'>
            <CollectionSelect
              externalProps={{
                onFocus: handleFocus,
                onBlur: handleBlur,
                isOptionDisabled,
                isValidNewOption: props.isValidNewOption,
                createOptionPosition: props.createOptionPosition,
                additionalNoOptionsMessage: props.additionalNoOptionsMessage,
              }}
              hideDropdown={true}
              isAsync={true}
              isAutoFocused={true}
              isCreatable={props.isCreatable}
              isSearchable={true}
              modifiers={['inline-form', 'inline-search', 'large-menu']}
              name={props.name}
              onChange={handleChange}
              options={loadOptions}
              placeholder={props.placeholder}
            />
          </div>
        </div>
      }
      setIsToggled={setIsToggled}
    />
  );
}

ToggleableSelect.defaultProps = {
  isCreatable: false,
  createOptionPosition: 'last',
};

ToggleableSelect.propTypes = {
  createOptionPosition: PropTypes.oneOf(['first', 'last']),
};
